<template>
  <div class="ws-participants__import">
    <b-upload v-model="file" @input="uploadFile" :accept="accept" class="is-fullwidth" :disabled="disabled">
      <a class="ws-button button is-fullwidth" :class="{'is-loading':isPending}">
        <span v-text="$t(`Загрузить ${fileType}-файл`)"></span>
      </a>
    </b-upload>
    <div class="block" v-if="fileType === 'XLSX'">
      <a class="is-size-4" @click.prevent="downloadXLSXExample">{{ $t(`Скачать пример XLSX-файла`) }}</a>
    </div>
    <div class="block" v-if="fileType === 'CSV'">
      <a class="is-size-4" href="/files/participants.csv" @click.prevent="downloadCSVExample">{{ $t(`Скачать пример CSV-файла`) }}</a>
    </div>
    <DragAndDropFile v-if="isDragAndDrop" :onChangeFiles="onChangeFiles"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'
import saveAs from 'file-saver'
import DragAndDropFile from '@/components/common/WsDragAndDropFile.vue'

const DURATION = 2 * 60 * 1000

export default {
  name: 'WsParticipantsImport',
  components: { DragAndDropFile },
  props: {
    format: String,
    disabled: Boolean,
    isDragAndDrop: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      isPending: false,
      file: null
    }
  },
  computed: {
    fileType () {
      switch (this.format) {
        case 'csv':
          return 'CSV'
        case 'xlsx':
          return 'XLSX'
        default:
          return 'XLSX'
      }
    },
    accept () {
      switch (this.format) {
        case 'csv':
          return '.csv, text/csv'
        case 'xlsx':
          return '.xlsx'
        default:
          return '.xlsx'
      }
    }
  },
  methods: {
    ...mapActions('esatk/users-list', ['uploadUsersList']),
    async onChangeFiles (files) {
      if (this.isPending) {
        return
      }
      Array.from(files).map((elem) => {
        this.uploadFile(elem)
      })
    },
    async uploadFile (currentFile) {
      const formData = new FormData()
      const file = currentFile || this.file
      formData.append('file', file, file.filename)
      formData.append('manual_url', `${__config.services.id}/activate`)
      formData.append('url', `${__config.services.id}/activated/{user_id}/{code}`)

      try {
        this.isPending = true
        const users = await this.uploadUsersList({
          'file': formData
        })
        this.$emit('input-users', users)
      } catch (e) {
        if (e.validation) {
          let message = ``
          Object.keys(e.validation).map(elem => {
            message += `${elem} - ${e.validation[elem]}<br/>`
          })
          this.$buefy.toast.open({
            duration: DURATION,
            message: `<div style="font-size: 12px">${message}</div>`,
            type: 'is-danger'
          })
        } else {
          this.$buefy.toast.open({
            message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
            type: 'is-danger'
          })
        }
      } finally {
        this.isPending = false
      }
    },
    async downloadXLSXExample () {
      const _file = await axios({
        url: `${__config.api_url}/api/dpws/general-files/file/${__config.files.participants_file_guid}?json=true`,
        method: 'get'
      }).then(response => response.data)

      window.location.href = _file.data.redirect_to
    },
    async downloadCSVExample () {
      const _file = await fetch(`/files/participants.csv`, { method: 'get' })
      saveAs(await _file.blob(), 'participants.csv')
    }
  }
}
</script>
